import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../Css/CardDetails.css';
import { useStateValue } from '../../Middleware/context/StateProvider';

function CardDetails({
  id,
  img,
  imgAlt = [],
  nameProduto,
  price,
  description,
  fornecedor,
  size,
  transportadora,
  color,
  destinoVenda,
  tipo,
  tipoArtigo,
  taxa,
  idSupplier
 
}) {
  const navigate = useNavigate();
  const { dispatch } = useStateValue();
const [transportadoraSelecionada, setTransportadoraSelecionada] = useState("");
const [selSize, setSelsize] = useState("");
const [selCor, setSelcor] = useState("");
  const [mainImage, setMainImage] = useState(img);
  const [quantity, setQuantity] = useState(1);


  const addToCart = () => {
 const tipoItem = tipoArtigo==='Produtos';

 tipoItem?
    dispatch({
      type: 'ADD_TO_BASKET',
      item: {
        id,
        img: mainImage,
        nameProduto,
        price:(price*quantity)+(taxa*quantity),
        description,
        fornecedor,
        tamanho:selSize,
        cor:selCor,
       destinoVenda,
        tipo,
        artigo:tipoArtigo,
        taxa,
        idSupplier,
        status:'Pending',
        quantidade: quantity,
        delivery:transportadoraSelecionada,
        data: new Date().toLocaleString(),
      }
    })
    :alert('Sem permissao para adicionar esse produto')
  
  }

  return (
    <div className="product-details">
      <button className="back-btn" onClick={() => navigate(-1)}>
        ← Voltar
      </button>

      <div className="product-container">
        <div className="product-images">
          <img src={mainImage} alt={nameProduto} className="main-image" />

          <div className="image-thumbs">
            {imgAlt.map((item, index) => (
              <img
                key={index}
                src={item}
                alt="thumb"
                onClick={() => setMainImage(item)}
              />
            ))}
          </div>
        </div>

        <div className="product-info">
          <h1>{nameProduto}</h1>
          <span className="supplier">Fornecedor: {fornecedor}</span>
            <p className="supplier">Disponivel Para:<span className='bold'>{destinoVenda} </span> </p>

            <p className="supplier">Selecionar Transportadora
              <select className='bold' value={transportadoraSelecionada}
            onChange={(e) => setTransportadoraSelecionada(e.target.value)} name="" id="">
                 <option key={""}> --Select---</option>
               {transportadora?.map((item, index)=>(  
                 
                    <option key={index}> : {item} </option>

              ))}
              </select>
              </p>
        <div>
                <p className="supplier">Tamanho
              <select className='bold' value={selSize}
            onChange={(e) => setSelsize(e.target.value)} name="" id="">
                <option key={""}> --Select---</option>
               {size?.map((item, index)=>(  
                    <option key={index}> : {item} </option>

              ))}
              </select>
              </p>

                  <p className="supplier">Cor
              <select className='bold' value={selCor}
            onChange={(e) => setSelcor(e.target.value)} name="" id="">
                <option key={""}> --Select---</option>
               {color?.map((item, index)=>(  
                    <option key={index}> : {item} </option>

              ))}
              </select>
              </p>
        </div>

          <p className="description">{description}</p>

          <span className="price">
            Kz {((price * quantity)+(taxa*quantity)).toLocaleString()}
          </span>

          <div className="quantity">
            <button onClick={() => quantity > 1 && setQuantity(quantity - 1)}>
              −
            </button>
            <span>{quantity}</span>
            <button onClick={() => setQuantity(quantity + 1)}>+</button>
          </div>

          <button className="add-cart" onClick={addToCart}>
            Adicionar ao carrinho
          </button>
        </div>
      </div>
    </div>
  );
}

export default CardDetails;
